export enum TxStatuses {
  FAIL = '0x00',
  SUCCESS = '0x01',
  PENDING = '0x02',
}

export const TxStatusesText = {
  [TxStatuses.FAIL]: 'failed',
  [TxStatuses.SUCCESS]: 'success',
  [TxStatuses.PENDING]: 'pending',
}

export enum TxTypes {
  REFUND = 'REFUND',
  REVOKE = 'REVOKE',
  APPROVE = 'APPROVE',
  AIRDROP = 'AIRDROP',
  TOP_UP_SELF_GENERATED = 'TOP_UP_SELF_GENERATED',
  AIRDROP_WITH_SIGNATURE = 'AIRDROP_WITH_SIGNATURE',
}

export enum AirdropStatus {
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILED = 'failed',
  NOT_STARTED = 'not started',
  INTERRUPTED = 'interrupted',
}
